import api from '@/shared/api';
import { buildTruthySearchParams, requestExcelBlobExport } from '@/shared/lib';
import type { SortOrder } from '@/shared/lib';

import type {
  RecordSearchType,
  RecordSortField,
  RecordStatusFilter,
} from '../lib/record-list-query';

export const RECORD_LIST_EXPORT_GENERIC_MESSAGE = 'Erro ao exportar. Tente novamente.';

/** No `page` nor `itemsPerPage`: the page open on the screen must not truncate the file. */
export interface RecordListExportParams {
  term?: string;
  searchType?: RecordSearchType;
  sort?: RecordSortField;
  order?: SortOrder;
  status?: RecordStatusFilter;
  generatedRecords?: string;
  includePreviousRevisions?: boolean;
}

const EXPORT_QUERY_KEYS = [
  'term',
  'searchType',
  'sort',
  'order',
  'status',
  'generatedRecords',
  'includePreviousRevisions',
] as const satisfies readonly (keyof RecordListExportParams)[];

export function buildRecordListExportQuery(
  params: RecordListExportParams
): RecordListExportParams {
  const term = params.term?.trim();

  return {
    ...params,
    term: term && term.length > 0 ? term : undefined,
    // `buildTruthySearchParams` drops `false`, and the endpoint reads an absent flag as false.
    includePreviousRevisions: params.includePreviousRevisions === true ? true : undefined,
  };
}

export async function exportRecordListExcel(
  params: RecordListExportParams
): Promise<{ blob: Blob; exportedCount: number; filename: string }> {
  const queryParams = buildTruthySearchParams(
    buildRecordListExportQuery(params),
    EXPORT_QUERY_KEYS
  );

  return requestExcelBlobExport(
    () =>
      api.get(`/matrices/latest-revisions/export/excel?${queryParams.toString()}`, {
        responseType: 'blob',
      }),
    'lista-registros.xlsx',
    RECORD_LIST_EXPORT_GENERIC_MESSAGE
  );
}
